import { render, staticRenderFns } from "./AccountChangePasswordForm.vue?vue&type=template&id=682e6325&scoped=true&"
import script from "./AccountChangePasswordForm.vue?vue&type=script&lang=js&"
export * from "./AccountChangePasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./AccountChangePasswordForm.vue?vue&type=style&index=0&id=682e6325&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682e6325",
  null
  
)

export default component.exports